// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	ViewEncumbranceLink: 'view-encumbrance-link',
	PurchaseSelectedButton: 'purchase-selected-button',
	SearchDocumentsButton: 'search-documents-button',
	AddInstrumentButton: 'add-instrument-button',
	EditRequisitionButton: 'edit-requisition-button',
	AddRequisitionButton: 'add-requisition-button',
	AddEncumbranceButton: 'add-encumbrance-button',
	ShowDeletedCheckbox: 'show-deleted-checkbox',
	SelectAllCheckbox: 'select-all-checkbox',
	ToggleSelectedInstrumentCheckbox: 'toggle-selected-instrument-checkbox',
	ToggleSelectedAttributeCheckbox: 'toggle-selected-attribute-checkbox',
	ExclamationIcon: 'exclamation-icon',
	CheckIcon: 'check-icon',
	AddIcon: 'add-icon',
	MinusIcon: 'minus-icon',
	PdfIcon: 'pdf-icon',
	LoadingIcon: 'loading-icon',
	PartiesIcon: 'parties-icon',
	PartiesIcon1: 'parties-icon-1',
	PdfIcon1: 'pdf-icon-1',
	LoadingIcon1: 'loading-icon-1',
	TypeFilterRadioGroup: 'type-filter-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
